/**
 * TASK 2: Category Normalization Utility
 * 
 * Normalizes category values for consistent comparison
 * Rules:
 * - lowercase
 * - trim spaces
 * - replace "&" with "and"
 * - replace spaces AND hyphens with "_"
 */
export function normalizeCategory(value: string | undefined | null): string {
  if (!value) return '';
  
  return value
    .toLowerCase()
    .trim()
    .replace(/&/g, 'and')
    .replace(/[\s\-]+/g, '_'); // Replace BOTH spaces AND hyphens with underscore
}

/**
 * Check if a service is active based on status field or isActive flag
 * A service is ACTIVE only if:
 * - status === "active" OR isActive === true
 * Anything else is inactive
 */
export function isServiceActive(service: { status?: string; isActive?: boolean }): boolean {
  // Check status field first
  if (service.status !== undefined) {
    return service.status === 'active';
  }
  
  // Fallback to isActive field
  // If isActive is undefined, default to true (backward compatibility)
  return service.isActive !== false;
}
